module.exports = __webpack_public_path__ + "img/t1-x1.ad155391.svg";